import classNames from "classnames";
import { useTranslation } from "react-i18next";

export interface Props {
    text?: string;
    className?: string;
    children?: React.ReactNode;
}

export function ErrorText({ text, className, children }: Props) {
    const klass = classNames("text-danger", className);
    const { t } = useTranslation();
    if (text) {
        return <div className={klass}>{t(text)}</div>;
    }

    if (children) {
        return <div className={klass}>{children}</div>;
    }

    return null;
}
